import { Dispatch, SetStateAction } from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import BarChartIcon from "@mui/icons-material/BarChart";
import GridOnIcon from "@mui/icons-material/GridOn";

export const SetChartView = (props: {
  isChartView: boolean;
  setIsChartView: Dispatch<SetStateAction<boolean>>;
  isLoading: boolean;
  /**
   * Views with no chart mode (e.g. Inventory Health) pass this to render the
   * toggle as visibly unavailable — grayed, no handler — instead of a
   * clickable-but-broken button.
   */
  unavailable?: boolean;
}) => {
  const { isChartView, setIsChartView, isLoading, unavailable } = props;

  if (unavailable) {
    return (
      <Tooltip title="Chart view unavailable on Inventory Health">
        {/* A plain span, not a disabled IconButton, so the tooltip still
            fires on hover (MUI suppresses hover events on disabled buttons). */}
        <Box
          component="span"
          sx={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: 32,
            height: 32,
            mt: 0.5,
            color: "#C9CDD3",
            cursor: "not-allowed",
          }}
        >
          <BarChartIcon />
        </Box>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={isChartView ? "View as pivot" : "View as chart"}>
      <IconButton
        onClick={() => setIsChartView((prev: boolean) => !prev)}
        disabled={isLoading}
        sx={{
          mt: 0.5,
        }}
      >
        {isChartView ? <GridOnIcon /> : <BarChartIcon />}
      </IconButton>
    </Tooltip>
  );
};
